export default from './Logos';



// WEBPACK FOOTER //
// ./src/containers/Logos/index.js